<form novalidate [formGroup]="couponForm" class="mt-2">
    @if (coupon) {
        <div>
            <div class="alert has-body" checkoutCy="promo_code_ticket_notification_block">
                <div class="icon">
                    <i class="tri-infos-circle"></i>
                </div>
                <div class="body">
                    <p>
                        <span>Félicitation! Votre code promo a été appliqué avec succès.</span>
                        <span class="has-text-weight-semibold" checkoutCy="promo_code_ticket_notification_promo_code">
                            {{ coupon.name }}
                        </span>
                    </p>
                    @if (showCouponInput) {
                        <button
                            (click)="removeCoupon()"
                            checkoutCy="promo_code_ticket_remove"
                            class="button is-primary is-small is-fullwidth"
                        >
                            Retirer
                        </button>
                    }
                </div>
            </div>
        </div>
    } @else {
        @if (showCouponInput) {
            <div class="columns is-mobile is-multiline is-aligned-center">
                <div class="column">
                    <div class="field">
                        <div
                            class="control has-dynamic-placeholder has-icons-left"
                            [ngClass]="showError && 'has-icons-right'"
                        >
                            <input
                                [formControl]="couponForm"
                                class="input"
                                [ngClass]="showError && 'is-error'"
                                id="coupon"
                                type="text"
                                placeholder="Code Promo"
                                required="true"
                                (focus)="showError = false"
                                checkoutCy="promo_code_ticket_label"
                            />
                            <label for="coupon">Code Promo</label>
                            <span class="icon has-icon-left">
                                <i class="tri-ecommerce-promo-label"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="column is-narrow">
                    <button
                        checkoutCy="promo_code_ticket_button"
                        (click)="checkCouponCode()"
                        class="button is-primary is-fullwidth no-min-width"
                        [ngClass]="{ 'is-loading': loading }"
                        [disabled]="!couponForm.value"
                        aria-label="Appliquer le code promo"
                    >
                        Appliquer
                    </button>
                </div>
            </div>
            @if (showError) {
                <p class="help is-error" checkoutCy="promo_code_ticket_error">
                    {{ errorMessage }}
                </p>
            }
        }
    }
</form>
